import(/* webpackMode: "eager" */ "/app/app/(public)/error.tsx");
